import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppInitializer } from './app-initializer';
import { GuestService } from './shared/services/guest.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'seat-widget';
  loader: boolean = false;
  bannerImg = '';
  logoImg = '';
  backgroundImg = '';
  widgetSettings: any = {};
  
  private subscriptions = new Subscription();

  constructor(
    private appIntializer: AppInitializer,
    public gs: GuestService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) {
    const configSettings = this.appIntializer.appConfigSettings();
    this.gs.ConfigSettings = configSettings;
  }

  ngOnInit() {
    // ✅ Move ALL subscriptions to ngOnInit and defer mutations
    
    this.subscriptions.add(
      this.gs.loader.subscribe(val => {
        // ✅ Defer the mutation outside change detection cycle
        setTimeout(() => {
          if (val) {
            this.spinner.show();
            this.loader = true;
          } else {
            this.loader = false;
            this.spinner.hide();
          }
        }, 0);
      })
    );

    // ✅ Also move merchantImgUrl subscription here and defer mutations
    this.subscriptions.add(
      this.gs.merchantImgUrl.subscribe((images: any) => {
        setTimeout(() => {
          this.bannerImg = images.bannerImg;
          this.logoImg = images.logoImg;
          this.backgroundImg = images.backgroundImg;
        }, 0);
      })
    );

    // ✅ Move widgetConfigurations subscription
    this.subscriptions.add(
      this.gs.widgetConfigurations.subscribe(config => {
        setTimeout(() => {
          this.widgetSettings = config;
        }, 0);
      })
    );
  }

  ngOnDestroy() {
    // ✅ Unsubscribe from all subscriptions to prevent memory leaks
    this.subscriptions.unsubscribe();
  }
}